import { studio410StoryFixture } from './fixtures';
import type { StoryIntelligence, StoryIntelligenceProvider } from './model';
export class FixtureStoryIntelligenceProvider implements StoryIntelligenceProvider {
  constructor(private readonly fixture: StoryIntelligence | null = studio410StoryFixture) {}
  async getStoryIntelligence(accountId: string, subjectId: string) { if (!this.fixture) return null; return this.fixture.account.id === accountId && this.fixture.subject.id === subjectId ? this.fixture : null; }
}
export const storyIntelligenceProvider = new FixtureStoryIntelligenceProvider();
